import { render, staticRenderFns } from "./AfterSalesOffice.vue?vue&type=template&id=0d5c45dc&"
import script from "./AfterSalesOffice.vue?vue&type=script&lang=js&"
export * from "./AfterSalesOffice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports